import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCurrentPackageUserModule } from "../services/api";
import AffirmationMessage from "../components/modules/affirmation/affirmationMessage";

const AffirmationPage = () => {
  const { id, moduleId } = useParams();
  const [userData, setUserData] = useState(null);
  const [ready, setReady] = useState(false);

  const fetchData = async () => {
    try {
      const data = await getCurrentPackageUserModule(id, moduleId);
      if (data.user) {
        setUserData(data);
        setReady(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id, moduleId]);

  if (!ready) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div>Yükleniyor...</div>
      </div>
    );
  }

  return <AffirmationMessage data={userData} />;
};

export default AffirmationPage;





















